import React from 'react';
import { ArrowForward } from '@mui/icons-material';
import { Card, Link, Row, Stack, Title } from 'library/ui';
import { ManagePaymentMethods } from 'shared/payments';
import { useUserContext } from 'UserContext';
import { toAssignableAddresses } from '../assignableAddresses';

const PaymentMethodsSection = () => {
    const { user } = useUserContext();

    return (
        <Card padding="lg">
            <Stack gap="md">
                <Row justify="between" align="center">
                    <Title size="h2">Payment Methods</Title>
                    <Link to="/payments/methods">
                        View all <ArrowForward sx={{ fontSize: 16 }} />
                    </Link>
                </Row>
                <ManagePaymentMethods
                    showRecruitDefault={false}
                    showAssignment
                    availableAddresses={toAssignableAddresses(user?.address)}
                    limit={2}
                />
            </Stack>
        </Card>
    );
};

export default PaymentMethodsSection;
